import { Pipe, PipeTransform } from '@angular/core';
import { ADDRESS3_LIST } from '@app/config/address.data';

@Pipe({
  name: 'address3Index'
})
export class Address3IndexPipe implements PipeTransform {

  public data = ADDRESS3_LIST.map(b => { return b });

  transform(value: any): number {

    return this.data.findIndex(x => +x.id === +value);
  }
}
